import { render, staticRenderFns } from "./stucomment.vue?vue&type=template&id=af2daa36&scoped=true"
import script from "./stucomment.vue?vue&type=script&lang=js"
export * from "./stucomment.vue?vue&type=script&lang=js"
import style0 from "./stucomment.vue?vue&type=style&index=0&id=af2daa36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2daa36",
  null
  
)

export default component.exports